module.exports = __webpack_public_path__ + "static/media/sql.1583a085.svg";